module.exports = __webpack_public_path__ + "static/media/icon-arrow-left-blue.5d15ddeb.svg";